import { IAccount } from "../models/IAccount";

export const appVirtualPath = "";
export const accountApiUrl = `${getBaseUrl()}/account/`;

export const LOG_IN: string = "LOG_IN";
export const LOG_OUT: string = "LOG_OUT";
export const SET_REDIRECT_URL: string = "SET_REDIRECT_URL";
export const CLEAR_REDIRECT_URL: string = "CLEAR_REDIRECT_URL";

interface ILogInActionType { type: string, account: IAccount };
interface ILogOutActionType { type: string };
interface ISetRedirectActionType { type: string, redirectUrl: string };
interface IClearRedirectActionType { type: string };

export function login(account: IAccount): ILogInActionType {
    return { type: LOG_IN, account: account };
}

export function logout(): ILogOutActionType {
    return { type: LOG_OUT};
}

export function setRedirectUrl(redirectUrl: string): ISetRedirectActionType {
    return { type: SET_REDIRECT_URL, redirectUrl: redirectUrl };
}

export function clearRedirectUrl(): IClearRedirectActionType {
    return { type: CLEAR_REDIRECT_URL };
}

/**
 * Gets the base application URL given the application can be hosted in a virtual path "/adminui"
 * or it can be running locally where the API will be from the root of the site.
 */
export function getBaseUrl(): string {
    let baseUrl: string = window.location.href.indexOf("localhost") >= 0 ? "" : appVirtualPath;

    return baseUrl;
}